import useGenericEntityStore from '@/layouts/entity/entityStoreModule'

const { storeModule } = useGenericEntityStore('hospitals')
export default storeModule
